import { useTranslation } from 'react-i18next'

import { AIButtonOutlined } from '../../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../../Button'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_GRETA_APPROVE,
  QA_NAME_DASHBOARD_BIRDVIEW_GRETA_EDIT,
  QA_NAME_DASHBOARD_BIRDVIEW_GRETA_REJECT,
} from '../../DashboardBirdview.constants.qa'

import * as styles from './BirdviewGretaRowActions.module.css'

// TODO Approve / Edit / Reject have no endpoint yet (Phase 3): the handlers
// are stubs until the proposals API ships.
function BirdviewGretaRowActions() {
  const { t } = useTranslation()

  function handleApprove() {}

  function handleEdit() {}

  function handleReject() {}

  return (
    <span className={styles.actions}>
      <AIButtonOutlined
        height={BUTTON_HEIGHT_24}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_GRETA_APPROVE}
        text={t('DashboardBirdview.GretaApproveKey')}
        onClick={handleApprove}
      />
      <AIButtonOutlined
        height={BUTTON_HEIGHT_24}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_GRETA_EDIT}
        text={t('DashboardBirdview.GretaEditKey')}
        onClick={handleEdit}
      />
      <AIButtonOutlined
        height={BUTTON_HEIGHT_24}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_GRETA_REJECT}
        text={t('DashboardBirdview.GretaRejectKey')}
        onClick={handleReject}
      />
    </span>
  )
}

export default BirdviewGretaRowActions
